import React from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useNavigate } from "react-router-dom";

const SignedApprovalPage = () => {
  const navigate = useNavigate();

  return (
    <div className="tw-min-h-screen tw-bg-gradient-to-br tw-from-[#ECFDF3] tw-to-white tw-flex tw-items-center tw-justify-center">
      <div className="tw-bg-white tw-rounded-2xl tw-shadow-lg tw-p-8 tw-max-w-md tw-w-full tw-mx-4 tw-text-center">
        <div className="tw-mb-6">
          <CheckCircleIcon
            className="tw-text-[#12B76A] tw-animate-bounce"
            style={{ fontSize: "80px" }}
          />
        </div>

        <h1 className="tw-text-2xl tw-font-bold tw-text-[#027A48] tw-mb-4">
          Document Approved Successfully!
        </h1>

        <p className="tw-text-gray-600 tw-mb-8">
          Thank you for signing the document. Your signature has been recorded
          and the document has been approved successfully.
        </p>
      </div>
    </div>
  );
};

export default SignedApprovalPage;
